<template>
  <div class="main-div">
    <v-container fluid grid-list-md :style="{ maxWidth: '1400px' }">
      <v-layout row wrap>
        <v-flex xs12 md12 lg12>
          <v-card class="my-3 pt-4" style="padding-left: 32px; padding-right: 32px;">
            <highcharts class="chart" :options="chartData"></highcharts>
            <p class="text-xs-center" style="padding-bottom: 16px">
              <span class="desc">
                <img
                  :src="
                    '/img/reserved_for_selling' + (darkmode ? '_dark' : '') + '.png'
                  "
                  width="20"
                  height="20"
                  class="desc-icon-first"
                />
                <img
                  :src="
                    '/img/reserved_for_selling_blue' +
                      (darkmode ? '_dark' : '') +
                      '.png'
                  "
                  width="20"
                  height="20"
                  class="desc-icon"
                />
                Reserved for selling
                <v-icon
                  class="vertical-align-middle icon-for-information"
                  style="font-size: 16px; margin-bottom: 1px;"
                  @click.stop.prevent
                  @click="
                    () => {
                      infoAlert(
                        $t('information.reserved_for_selling.title'),
                        $t('information.reserved_for_selling.description')
                      );
                    }
                  "
                >fa-info-circle</v-icon
                >
              </span>
              <br v-if="windowWidth < 595" />
              <span class="between-icons desc">
                <img
                    :src="'/img/in_open_buy_orders' + (darkmode ? '_dark' : '') + '.png'"
                    width="20"
                    height="20"
                    class="desc-icon"
                />
                In open buy orders
              </span>
            </p>
          </v-card>
          <v-card v-if="binanceAllocations.length > 0" class="my-3">
            <v-card-text>
              <div>
                <p class="title text-xs-left">
                  Binance
                </p>
                <p class="timestamp">
                  Last updated:
                  {{
                    allocations.timestamps["Binance"]
                      | formatDate("(z) DD MMM YYYY HH:mm")
                  }}
                </p>
                <v-data-table
                  class="ml-3"
                  :headers="tableHeaders"
                  :items="binanceAllocations"
                  :custom-sort="customTableSort"
                  must-sort
                  :rows-per-page-items="[
                    { text: 'All', value: -1 },
                    10,
                    25,
                    50
                  ]"
                  :pagination.sync="pagination['binance']"
                  item-key="market_name_table"
                >
                  <template slot="headers" slot-scope="props">
                    <tr>
                      <th
                        v-for="header in props.headers"
                        :key="header.text"
                        :class="[
                          'column sortable text-xs-left',
                          pagination['binance'].descending ? 'desc' : 'asc',
                          header.value === pagination['binance'].sortBy
                            ? 'active'
                            : ''
                        ]"
                        :aria-sort="
                          pagination['binance'].descending
                            ? 'descending'
                            : 'ascending'
                        "
                        @click="changeSort(header, 'binance')"
                      >
                        {{ header.text }}
                        <v-icon small>arrow_upward</v-icon>
                        <v-icon
                          v-if="header.text == 'Unrealised loss'"
                          class="vertical-align-middle icon-for-information"
                          style="font-size: 16px; opacity: 1; transform: none !important; -webkit-transform: none !important;"
                          @click.stop.prevent
                          @click="
                            () => {
                              infoAlert(
                                $t('information.unrealised_losses.title'),
                                $t('information.unrealised_losses.description')
                              );
                            }
                          "
                          >fa-info-circle</v-icon
                        >
                        <v-icon
                          v-if="header.text == 'Fractional acc val'"
                          class="vertical-align-middle icon-for-information"
                          style="font-size: 16px; opacity: 1; transform: none !important; -webkit-transform: none !important;"
                          @click.stop.prevent
                          @click="
                            () => {
                              infoAlert(
                                $t('dashboard.fractional_account_value_title'),
                                $t('dashboard.fractional_account_value_text')
                              );
                            }
                          "
                          >fa-info-circle</v-icon
                        >
                        <v-icon
                          v-if="header.text == 'Bag size (%)'"
                          class="vertical-align-middle icon-for-information"
                          style="font-size: 16px; opacity: 1; transform: none !important; -webkit-transform: none !important;"
                          @click.stop.prevent
                          @click="
                            () => {
                              infoAlert(
                                $t('information.allocations_bag_size.title'),
                                $t(
                                  'information.allocations_bag_size.description'
                                )
                              );
                            }
                          "
                          >fa-info-circle</v-icon
                        >
                        <v-icon
                          v-if="header.text == 'Funding health (%)'"
                          class="vertical-align-middle icon-for-information"
                          style="font-size: 16px; opacity: 1; transform: none !important; -webkit-transform: none !important;"
                          @click.stop.prevent
                          @click="
                            () => {
                              infoAlert(
                                $t('information.funding_health_pct.title'),
                                $t('information.funding_health_pct.description')
                              );
                            }
                          "
                          >fa-info-circle</v-icon
                        >
                      </th>
                    </tr>
                  </template>
                  <template slot="items" slot-scope="props">
                    <tr
                      v-if="isMobile"
                      @click="props.expanded = !props.expanded"
                    >
                      <td class="pb-3 pt-2">
                        <v-layout row wrap>
                          <v-flex md12 xs12>
                            <v-layout row wrap>
                              <v-flex xs12 lg12 md12>
                                <strong>{{
                                  props.item.market_name_table
                                }}</strong>
                              </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                              <v-flex xs6 lg6 md6>
                                Market name
                              </v-flex>
                              <v-flex xs6 lg6 md6>
                                {{ props.item.market_name_table }}
                              </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                              <v-flex xs6 lg6 md6>
                                Fractional acc val
                                <v-icon
                                  class="vertical-align-middle icon-for-information"
                                  style="font-size: 13px; opacity: 1; transform: none !important; -webkit-transform: none !important;"
                                  @click.stop.prevent
                                  @click="
                                    () => {
                                      infoAlert(
                                        $t(
                                          'dashboard.fractional_account_value_title'
                                        ),
                                        $t(
                                          'dashboard.fractional_account_value_text'
                                        )
                                      );
                                    }
                                  "
                                  >fa-info-circle</v-icon
                                >
                              </v-flex>
                              <v-flex xs6 lg6 md6>
                                {{
                                  props.item.managed_acc_val
                                    | roundMarketsFractionalAccountValue
                                }}
                              </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                              <v-flex xs6 lg6 md6>
                                Managed val (USD)
                              </v-flex>
                              <v-flex xs6 lg6 md6>
                                {{
                                  props.item.managed_value_usd | roundNumber(0)
                                }}
                              </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                              <v-flex xs6 lg6 md6>
                                Open buys vol
                              </v-flex>
                              <v-flex xs6 lg6 md6>
                                {{ props.item.fe_in_open_buys_quote | roundQuantity }}
                              </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                              <v-flex xs6 lg6 md6>
                                Current alloc (%)
                              </v-flex>
                              <v-flex xs6 lg6 md6>
                                {{
                                  props.item.current_alloc
                                    | roundNumber(0)
                                }}
                              </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                              <v-flex xs6 lg6 md6>
                                Configured alloc (%)
                              </v-flex>
                              <v-flex xs6 lg6 md6>
                                {{ props.item.set_alloc_perc | roundNumber(0) }}
                              </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                              <v-flex xs6 lg6 md6>
                                Bag size (%)
                                <v-icon
                                  class="vertical-align-middle icon-for-information"
                                  style="font-size: 13px; opacity: 1; transform: none !important; -webkit-transform: none !important;"
                                  @click.stop.prevent
                                  @click="
                                    () => {
                                      infoAlert(
                                        $t(
                                          'information.allocations_bag_size.title'
                                        ),
                                        $t(
                                          'information.allocations_bag_size.description'
                                        )
                                      );
                                    }
                                  "
                                  >fa-info-circle</v-icon
                                >
                              </v-flex>
                              <v-flex xs6 lg6 md6>
                                {{ props.item.fe_bag_size_pct | roundNumber(0) }}
                              </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                              <v-flex xs6 lg6 md6>
                                Unrealised loss
                                <v-icon
                                  class="vertical-align-middle icon-for-information"
                                  style="font-size: 13px; opacity: 1; transform: none !important; -webkit-transform: none !important;"
                                  @click.stop.prevent
                                  @click="
                                    () => {
                                      infoAlert(
                                        $t(
                                          'information.unrealised_losses.title'
                                        ),
                                        $t(
                                          'information.unrealised_losses.description'
                                        )
                                      );
                                    }
                                  "
                                  >fa-info-circle</v-icon
                                >
                              </v-flex>
                              <v-flex xs6 lg6 md6>
                                {{
                                  props.item.unrealised_loss | roundNumber(4)
                                }}
                              </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                              <v-flex xs6 lg6 md6>
                                Funding health (%)
                                <v-icon
                                  class="vertical-align-middle icon-for-information"
                                  style="font-size: 13px; opacity: 1; transform: none !important; -webkit-transform: none !important;"
                                  @click.stop.prevent
                                  @click="
                                    () => {
                                      infoAlert(
                                        $t('information.funding_health_pct.title'),
                                        $t('information.funding_health_pct.description')
                                      );
                                    }
                                  "
                                  >fa-info-circle</v-icon
                                >
                              </v-flex>
                              <v-flex xs6 lg6 md6>
                                {{ props.item.fe_funding_health_pct }}
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                      </td>
                    </tr>
                    <tr v-else @click="props.expanded = !props.expanded">
                      <td>{{ props.item.market_name_table }}</td>
                      <td>
                        {{
                          props.item.managed_acc_val
                            | roundMarketsFractionalAccountValue
                        }}
                      </td>
                      <td>
                        {{ props.item.managed_value_usd | roundNumber(0) }}
                      </td>
                      <td>
                        {{ props.item.fe_in_open_buys_quote | roundQuantity }}
                      </td>
                      <td>
                        {{
                            props.item.current_alloc
                            | roundNumber(0)
                        }}
                      </td>
                      <td>
                        {{ props.item.set_alloc_perc | roundNumber(0) }}
                      </td>
                      <td>
                        {{ props.item.fe_bag_size_pct | roundNumber(0) }}
                      </td>
                      <td>
                        {{ props.item.unrealised_loss | roundNumber(4) }}
                      </td>
                      <td>
                        {{ props.item.fe_funding_health_pct }}
                      </td>
                    </tr>
                  </template>
                  <template v-slot:expand="props">
                    <MarketAllocationsExpandedSettings
                      :name="props.item.market_name"
                    ></MarketAllocationsExpandedSettings>
                  </template>
                </v-data-table>
              </div>
            </v-card-text>
          </v-card>
          <v-card v-if="bittrexAllocations.length > 0" class="my-3">
            <v-card-text>
              <div>
                <p class="title text-xs-left">
                  Bittrex
                </p>
                <p class="timestamp">
                  Last updated:
                  {{
                    allocations.timestamps["Bittrex"]
                      | formatDate("(z) DD MMM YYYY HH:mm")
                  }}
                </p>
                <v-data-table
                  class="ml-3"
                  :headers="tableHeaders"
                  :items="bittrexAllocations"
                  :custom-sort="customTableSort"
                  must-sort
                  :rows-per-page-items="[
                    { text: 'All', value: -1 },
                    10,
                    25,
                    50
                  ]"
                  :pagination.sync="pagination['bittrex']"
                  item-key="market_name_table"
                >
                  <template slot="headers" slot-scope="props">
                    <tr>
                      <th
                        v-for="header in props.headers"
                        :key="header.text"
                        :class="[
                          'column sortable text-xs-left',
                          pagination['bittrex'].descending ? 'desc' : 'asc',
                          header.value === pagination['bittrex'].sortBy
                            ? 'active'
                            : ''
                        ]"
                        :aria-sort="
                          pagination['bittrex'].descending
                            ? 'descending'
                            : 'ascending'
                        "
                        @click="changeSort(header, 'bittrex')"
                      >
                        {{ header.text }}
                        <v-icon small>arrow_upward</v-icon>
                        <v-icon
                          v-if="header.text == 'Unrealised loss'"
                          class="vertical-align-middle icon-for-information"
                          style="font-size: 16px; opacity: 1; transform: none !important; -webkit-transform: none !important;"
                          @click.stop.prevent
                          @click="
                            () => {
                              infoAlert(
                                $t('information.unrealised_losses.title'),
                                $t('information.unrealised_losses.description')
                              );
                            }
                          "
                          >fa-info-circle</v-icon
                        >
                        <v-icon
                          v-if="header.text == 'Fractional acc val'"
                          class="vertical-align-middle icon-for-information"
                          style="font-size: 16px; opacity: 1; transform: none !important; -webkit-transform: none !important;"
                          @click.stop.prevent
                          @click="
                            () => {
                              infoAlert(
                                $t('dashboard.fractional_account_value_title'),
                                $t('dashboard.fractional_account_value_text')
                              );
                            }
                          "
                          >fa-info-circle</v-icon
                        >
                        <v-icon
                          v-if="header.text == 'Bag size (%)'"
                          class="vertical-align-middle icon-for-information"
                          style="font-size: 16px; opacity: 1; transform: none !important; -webkit-transform: none !important;"
                          @click.stop.prevent
                          @click="
                            () => {
                              infoAlert(
                                $t('information.allocations_bag_size.title'),
                                $t(
                                  'information.allocations_bag_size.description'
                                )
                              );
                            }
                          "
                          >fa-info-circle</v-icon
                        >
                        <v-icon
                          v-if="header.text == 'Funding health (%)'"
                          class="vertical-align-middle icon-for-information"
                          style="font-size: 16px; opacity: 1; transform: none !important; -webkit-transform: none !important;"
                          @click.stop.prevent
                          @click="
                            () => {
                              infoAlert(
                                $t('information.funding_health_pct.title'),
                                $t('information.funding_health_pct.description')
                              );
                            }
                          "
                          >fa-info-circle</v-icon
                        >
                      </th>
                    </tr>
                  </template>
                  <template slot="items" slot-scope="props">
                    <tr
                      v-if="isMobile"
                      @click="props.expanded = !props.expanded"
                    >
                      <td class="pb-3 pt-2">
                        <v-layout row wrap>
                          <v-flex md12 xs12>
                            <v-layout row wrap>
                              <v-flex xs12 lg12 md12>
                                <strong>{{
                                  props.item.market_name_table
                                }}</strong>
                              </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                              <v-flex xs6 lg6 md6>
                                Market name
                              </v-flex>
                              <v-flex xs6 lg6 md6>
                                {{ props.item.market_name_table }}
                              </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                              <v-flex xs6 lg6 md6>
                                Fractional acc val
                                <v-icon
                                  class="vertical-align-middle icon-for-information"
                                  style="font-size: 13px; opacity: 1; transform: none !important; -webkit-transform: none !important;"
                                  @click.stop.prevent
                                  @click="
                                    () => {
                                      infoAlert(
                                        $t(
                                          'dashboard.fractional_account_value_title'
                                        ),
                                        $t(
                                          'dashboard.fractional_account_value_text'
                                        )
                                      );
                                    }
                                  "
                                  >fa-info-circle</v-icon
                                >
                              </v-flex>
                              <v-flex xs6 lg6 md6>
                                {{
                                  props.item.managed_acc_val
                                    | roundMarketsFractionalAccountValue
                                }}
                              </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                              <v-flex xs6 lg6 md6>
                                Managed val (USD)
                              </v-flex>
                              <v-flex xs6 lg6 md6>
                                {{
                                  props.item.managed_value_usd | roundNumber(0)
                                }}
                              </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                              <v-flex xs6 lg6 md6>
                                Open buys vol
                              </v-flex>
                              <v-flex xs6 lg6 md6>
                                {{ props.item.fe_in_open_buys_quote | roundQuantity }}
                              </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                              <v-flex xs6 lg6 md6>
                                Current alloc (%)
                              </v-flex>
                              <v-flex xs6 lg6 md6>
                                {{
                                  props.item.current_alloc
                                    | roundNumber(0)
                                }}
                              </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                              <v-flex xs6 lg6 md6>
                                Configured alloc (%)
                              </v-flex>
                              <v-flex xs6 lg6 md6>
                                {{ props.item.set_alloc_perc | roundNumber(0) }}
                              </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                              <v-flex xs6 lg6 md6>
                                Bag size (%)
                                <v-icon
                                  class="vertical-align-middle icon-for-information"
                                  style="font-size: 13px; opacity: 1; transform: none !important; -webkit-transform: none !important;"
                                  @click.stop.prevent
                                  @click="
                                    () => {
                                      infoAlert(
                                        $t(
                                          'information.allocations_bag_size.title'
                                        ),
                                        $t(
                                          'information.allocations_bag_size.description'
                                        )
                                      );
                                    }
                                  "
                                  >fa-info-circle</v-icon
                                >
                              </v-flex>
                              <v-flex xs6 lg6 md6>
                                {{ props.item.fe_bag_size_pct | roundNumber(0) }}
                              </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                              <v-flex xs6 lg6 md6>
                                Unrealised loss
                                <v-icon
                                  class="vertical-align-middle icon-for-information"
                                  style="font-size: 13px; opacity: 1; transform: none !important; -webkit-transform: none !important;"
                                  @click.stop.prevent
                                  @click="
                                    () => {
                                      infoAlert(
                                        $t(
                                          'information.unrealised_losses.title'
                                        ),
                                        $t(
                                          'information.unrealised_losses.description'
                                        )
                                      );
                                    }
                                  "
                                  >fa-info-circle</v-icon
                                >
                              </v-flex>
                              <v-flex xs6 lg6 md6>
                                {{
                                  props.item.unrealised_loss | roundNumber(4)
                                }}
                              </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                              <v-flex xs6 lg6 md6>
                                Funding health (%)
                                <v-icon
                                  class="vertical-align-middle icon-for-information"
                                  style="font-size: 13px; opacity: 1; transform: none !important; -webkit-transform: none !important;"
                                  @click.stop.prevent
                                  @click="
                                    () => {
                                      infoAlert(
                                        $t('information.funding_health_pct.title'),
                                        $t('information.funding_health_pct.description')
                                      );
                                    }
                                  "
                                  >fa-info-circle</v-icon
                                >
                              </v-flex>
                              <v-flex xs6 lg6 md6>
                                {{ props.item.fe_funding_health_pct }}
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                      </td>
                    </tr>
                    <tr v-else @click="props.expanded = !props.expanded">
                      <td>{{ props.item.market_name_table }}</td>
                      <td>
                        {{
                          props.item.managed_acc_val
                            | roundMarketsFractionalAccountValue
                        }}
                      </td>
                      <td>
                        {{ props.item.managed_value_usd | roundNumber(0) }}
                      </td>
                      <td>
                        {{ props.item.fe_in_open_buys_quote | roundQuantity }}
                      </td>
                      <td>
                        {{
                          props.item.current_alloc
                            | roundNumber(0)
                        }}
                      </td>
                      <td>
                        {{ props.item.set_alloc_perc | roundNumber(0) }}
                      </td>
                      <td>
                        {{ props.item.fe_bag_size_pct | roundNumber(0) }}
                      </td>
                      <td>
                        {{ props.item.unrealised_loss | roundNumber(4) }}
                      </td>
                      <td>
                        {{ props.item.fe_funding_health_pct }}
                      </td>
                    </tr>
                  </template>
                  <template v-slot:expand="props">
                    <MarketAllocationsExpandedSettings
                      :name="props.item.market_name"
                    ></MarketAllocationsExpandedSettings>
                  </template>
                </v-data-table>
              </div>
            </v-card-text>
          </v-card>
          <v-card v-if="huobiAllocations.length > 0" class="my-3">
            <v-card-text>
              <div>
                <p class="title text-xs-left">
                  Huobi
                </p>
                <p class="timestamp">
                  Last updated:
                  {{
                    allocations.timestamps["Huobi"]
                      | formatDate("(z) DD MMM YYYY HH:mm")
                  }}
                </p>
                <v-data-table
                  class="ml-3"
                  :headers="tableHeaders"
                  :items="huobiAllocations"
                  :custom-sort="customTableSort"
                  must-sort
                  :rows-per-page-items="[
                    { text: 'All', value: -1 },
                    10,
                    25,
                    50
                  ]"
                  :pagination.sync="pagination['huobi']"
                  item-key="market_name_table"
                >
                  <template slot="headers" slot-scope="props">
                    <tr>
                      <th
                        v-for="header in props.headers"
                        :key="header.text"
                        :class="[
                          'column sortable text-xs-left',
                          pagination['huobi'].descending ? 'desc' : 'asc',
                          header.value === pagination['huobi'].sortBy
                            ? 'active'
                            : ''
                        ]"
                        :aria-sort="
                          pagination['huobi'].descending
                            ? 'descending'
                            : 'ascending'
                        "
                        @click="changeSort(header, 'huobi')"
                      >
                        {{ header.text }}
                        <v-icon small>arrow_upward</v-icon>
                        <v-icon
                          v-if="header.text == 'Unrealised loss'"
                          class="vertical-align-middle icon-for-information"
                          style="font-size: 16px; opacity: 1; transform: none !important; -webkit-transform: none !important;"
                          @click.stop.prevent
                          @click="
                            () => {
                              infoAlert(
                                $t('information.unrealised_losses.title'),
                                $t('information.unrealised_losses.description')
                              );
                            }
                          "
                          >fa-info-circle</v-icon
                        >
                        <v-icon
                          v-if="header.text == 'Fractional acc val'"
                          class="vertical-align-middle icon-for-information"
                          style="font-size: 16px; opacity: 1; transform: none !important; -webkit-transform: none !important;"
                          @click.stop.prevent
                          @click="
                            () => {
                              infoAlert(
                                $t('dashboard.fractional_account_value_title'),
                                $t('dashboard.fractional_account_value_text')
                              );
                            }
                          "
                          >fa-info-circle</v-icon
                        >
                        <v-icon
                          v-if="header.text == 'Bag size (%)'"
                          class="vertical-align-middle icon-for-information"
                          style="font-size: 16px; opacity: 1; transform: none !important; -webkit-transform: none !important;"
                          @click.stop.prevent
                          @click="
                            () => {
                              infoAlert(
                                $t('information.allocations_bag_size.title'),
                                $t(
                                  'information.allocations_bag_size.description'
                                )
                              );
                            }
                          "
                          >fa-info-circle</v-icon
                        >
                        <v-icon
                          v-if="header.text == 'Funding health (%)'"
                          class="vertical-align-middle icon-for-information"
                          style="font-size: 16px; opacity: 1; transform: none !important; -webkit-transform: none !important;"
                          @click.stop.prevent
                          @click="
                            () => {
                              infoAlert(
                                $t('information.funding_health_pct.title'),
                                $t('information.funding_health_pct.description')
                              );
                            }
                          "
                          >fa-info-circle</v-icon
                        >
                      </th>
                    </tr>
                  </template>
                  <template slot="items" slot-scope="props">
                    <tr
                      v-if="isMobile"
                      @click="props.expanded = !props.expanded"
                    >
                      <td class="pb-3 pt-2">
                        <v-layout row wrap>
                          <v-flex md12 xs12>
                            <v-layout row wrap>
                              <v-flex xs12 lg12 md12>
                                <strong>
                                  {{ props.item.market_name_table }}
                                </strong>
                              </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                              <v-flex xs6 lg6 md6>
                                Market name
                              </v-flex>
                              <v-flex xs6 lg6 md6>
                                {{ props.item.market_name_table }}
                              </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                              <v-flex xs6 lg6 md6>
                                Fractional acc val
                                <v-icon
                                  class="vertical-align-middle icon-for-information"
                                  style="font-size: 13px; opacity: 1; transform: none !important; -webkit-transform: none !important;"
                                  @click.stop.prevent
                                  @click="
                                    () => {
                                      infoAlert(
                                        $t(
                                          'dashboard.fractional_account_value_title'
                                        ),
                                        $t(
                                          'dashboard.fractional_account_value_text'
                                        )
                                      );
                                    }
                                  "
                                  >fa-info-circle</v-icon
                                >
                              </v-flex>
                              <v-flex xs6 lg6 md6>
                                {{
                                  props.item.managed_acc_val
                                    | roundMarketsFractionalAccountValue
                                }}
                              </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                              <v-flex xs6 lg6 md6>
                                Managed val (USD)
                              </v-flex>
                              <v-flex xs6 lg6 md6>
                                {{
                                  props.item.managed_value_usd | roundNumber(0)
                                }}
                              </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                              <v-flex xs6 lg6 md6>
                                Open buys vol
                              </v-flex>
                              <v-flex xs6 lg6 md6>
                                {{ props.item.fe_in_open_buys_quote | roundQuantity }}
                              </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                              <v-flex xs6 lg6 md6>
                                Current alloc (%)
                              </v-flex>
                              <v-flex xs6 lg6 md6>
                                {{
                                  props.item.current_alloc
                                    | roundNumber(0)
                                }}
                              </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                              <v-flex xs6 lg6 md6>
                                Configured alloc (%)
                              </v-flex>
                              <v-flex xs6 lg6 md6>
                                {{ props.item.set_alloc_perc | roundNumber(0) }}
                              </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                              <v-flex xs6 lg6 md6>
                                Bag size (%)
                                <v-icon
                                  class="vertical-align-middle icon-for-information"
                                  style="font-size: 13px; opacity: 1; transform: none !important; -webkit-transform: none !important;"
                                  @click.stop.prevent
                                  @click="
                                    () => {
                                      infoAlert(
                                        $t(
                                          'information.allocations_bag_size.title'
                                        ),
                                        $t(
                                          'information.allocations_bag_size.description'
                                        )
                                      );
                                    }
                                  "
                                  >fa-info-circle</v-icon
                                >
                              </v-flex>
                              <v-flex xs6 lg6 md6>
                                {{ props.item.fe_bag_size_pct | roundNumber(0) }}
                              </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                              <v-flex xs6 lg6 md6>
                                Unrealised loss
                                <v-icon
                                  class="vertical-align-middle icon-for-information"
                                  style="font-size: 13px; opacity: 1; transform: none !important; -webkit-transform: none !important;"
                                  @click.stop.prevent
                                  @click="
                                    () => {
                                      infoAlert(
                                        $t(
                                          'information.unrealised_losses.title'
                                        ),
                                        $t(
                                          'information.unrealised_losses.description'
                                        )
                                      );
                                    }
                                  "
                                  >fa-info-circle</v-icon
                                >
                              </v-flex>
                              <v-flex xs6 lg6 md6>
                                {{
                                  props.item.unrealised_loss | roundNumber(4)
                                }}
                              </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                              <v-flex xs6 lg6 md6>
                                Funding health (%)
                                <v-icon
                                  class="vertical-align-middle icon-for-information"
                                  style="font-size: 13px; opacity: 1; transform: none !important; -webkit-transform: none !important;"
                                  @click.stop.prevent
                                  @click="
                                    () => {
                                      infoAlert(
                                        $t('information.funding_health_pct.title'),
                                        $t('information.funding_health_pct.description')
                                      );
                                    }
                                  "
                                  >fa-info-circle</v-icon
                                >
                              </v-flex>
                              <v-flex xs6 lg6 md6>
                                {{ props.item.fe_funding_health_pct }}
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                      </td>
                    </tr>
                    <tr v-else @click="props.expanded = !props.expanded">
                      <td>
                        {{ props.item.market_name_table }}
                      </td>
                      <td>
                        {{
                          props.item.managed_acc_val
                            | roundMarketsFractionalAccountValue
                        }}
                      </td>
                      <td>
                        {{ props.item.managed_value_usd | roundNumber(0) }}
                      </td>
                      <td>
                        {{ props.item.fe_in_open_buys_quote | roundQuantity }}
                      </td>
                      <td>
                        {{
                          props.item.current_alloc
                            | roundNumber(0)
                        }}
                      </td>
                      <td>
                        {{ props.item.set_alloc_perc | roundNumber(0) }}
                      </td>
                      <td>
                        {{ props.item.fe_bag_size_pct | roundNumber(0) }}
                      </td>
                      <td>
                        {{ props.item.unrealised_loss | roundNumber(4) }}
                      </td>
                      <td>
                        {{ props.item.fe_funding_health_pct }}
                      </td>
                    </tr>
                  </template>
                  <template v-slot:expand="props">
                    <MarketAllocationsExpandedSettings
                      :name="props.item.market_name"
                    ></MarketAllocationsExpandedSettings>
                  </template>
                </v-data-table>
              </div>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<style scoped>
.desc-icon {
  margin-right: 16px;
  margin-bottom: -5px;
}
.desc-icon-first {
  margin-right: 0px !important;
  margin-bottom: -5px;
}
.between-icons {
  margin-left: 40px !important;
}
.theme--light span.desc {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
  color: #7395d0;
}
.highcharts-button-box {
  width: 32px;
  height: 32px;
}
>>> .highcharts-button-symbol {
  width: 32px;
  height: 32px;
  transform: translate(-6, -4);
}
>>> .theme--light .highcharts-button-hover .highcharts-button-box,
>>> .theme--light .highcharts-button-pressed .highcharts-button-box {
  fill: #ffffff;
}
>>> th,
>>> td {
  padding-left: 0px !important;
}
>>> .v-tabs__bar {
  border-radius: initial !important;
}
.theme--light.application .main-div {
  background-color: #f2f7ff !important;
}
>>> .theme--light.v-sheet {
  background: #ffffff;
  box-shadow: 4px 6px 20px rgba(57, 95, 169, 0.18);
  border-radius: 15px;
}
>>> .theme--light p.title {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: bold;
  font-size: 22px;
  line-height: 26px;
  color: #103a84;
  margin: 16px 16px 8px;
}
>>> .theme--light .timestamp {
  font-family: "Lato", serif !important;
  color: #7395d0;
  font-size: 13px;
  line-height: 140%;
  margin-left: 16px;
}
>>> .theme--light.v-datatable thead th {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 14px;
  color: #7395d0;
}
>>> .theme--light.v-datatable tbody tr td {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
  color: #103a84;
}

>>> .theme--light.v-datatable tbody tr td .v-btn {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
  color: #103a84;
}
>>> .theme--light.v-datatable thead th.column.sortable.active,
>>> .theme--light.v-datatable thead th.column.sortable.active .v-icon,
>>> .theme--light.v-datatable thead th.column.sortable:hover {
  color: #103a84;
}
>>> .theme--light .v-datatable__actions {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 16px;
  letter-spacing: 0.02em;
  color: #7395d0;
}
>>> .theme--light .v-datatable__actions .v-select__selections {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
  color: #103a84 !important;
  max-height: 24px;
}

>>> .theme--light
  .v-datatable__actions
  .v-select__selection.v-select__selection--comma {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
  color: #103a84;
  padding-left: 8px;
}

>>> .theme--light .v-datatable__actions .v-input__slot {
  border: 0.8px solid #103a84;
  box-sizing: border-box;
  border-radius: 5px;
  max-height: 24px;
}

>>> .v-datatable__actions
  .v-text-field
  > .v-input__control
  > .v-input__slot::after,
>>> .v-datatable__actions
  .v-text-field
  > .v-input__control
  > .v-input__slot::before {
  width: 0px;
}
>>> .theme--light .v-datatable__actions .v-btn {
  color: #103a84;
}
>>> .v-datatable__actions .theme--light.v-icon {
  color: #103a84 !important;
}
>>> .v-datatable__actions .v-input__append-inner {
  margin-top: 0px !important;
}
>>> .theme--light.v-btn.v-btn--disabled,
>>> .theme--light.v-btn.v-btn--disabled .v-btn__loading,
>>> .theme--light.v-btn.v-btn--disabled .v-icon {
  color: #b8d2ff !important;
}
>>> .theme--light.v-table thead tr:first-child {
  border-bottom: 1px solid #e6efff;
}
>>> .theme--light.v-table tbody tr:not(:first-child) {
  border-top: 1px solid #e6efff;
}

>>> .theme--light.v-datatable .v-datatable__actions {
  border-top: 1px solid #e6efff;
}

>>> .theme--light.v-datatable .v-datatable__expand-col--expanded {
  border-bottom: 1px solid #e6efff;
}

>>> .theme--dark p.title {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: bold;
  font-size: 22px;
  line-height: 26px;
  color: #e9e9e9;
  margin-top: 16px;
  margin-left: 16px;
  margin-right: 16px;
  margin-bottom: 8px;
}
>>> .theme--dark .timestamp {
  font-family: "Lato", serif !important;
  color: rgba(235, 235, 245, 0.6);
  font-size: 13px;
  line-height: 140%;
  margin-left: 16px;
}
>>> .theme--dark.v-sheet {
  background: #212121;
  border-radius: 15px;
}

>>> .theme--dark.v-table {
  background: #212121;
}
>>> .theme--dark.v-datatable .v-datatable__actions {
  background: #212121;
}
>>> .theme--dark.v-datatable thead th {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 14px;
  color: rgba(235, 235, 245, 0.6);
}
>>> .theme--dark.v-datatable tbody tr td {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
  color: #e9e9e9;
}
>>> .theme--dark.v-datatable tbody tr td .v-btn {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
}
>>> .theme--dark.v-datatable thead th.column.sortable.active,
>>> .theme--dark.v-datatable thead th.column.sortable.active .v-icon,
>>> .theme--dark.v-datatable thead th.column.sortable:hover {
  color: #ffffff;
}
>>> .theme--dark .v-datatable__actions {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 16px;
  letter-spacing: 0.02em;
  color: rgba(235, 235, 245, 0.6);
}
>>> .theme--dark .v-datatable__actions .v-select__selections {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
  max-height: 24px;
  color: rgba(235, 235, 245, 0.6);
}

>>> .theme--dark
  .v-datatable__actions
  .v-select__selection.v-select__selection--comma {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
  padding-left: 8px;
  color: #ffffff;
}

>>> .theme--dark .v-datatable__actions .v-input__slot {
  border: 0.8px solid #ffffff;
  box-sizing: border-box;
  border-radius: 5px;
  max-height: 24px;
}
>>> .v-datatable__actions .theme--dark.v-icon {
  color: #ffffff !important;
}
>>> .theme--dark.v-btn.v-btn--disabled,
>>> .theme--dark.v-btn.v-btn--disabled .v-btn__loading,
>>> .theme--dark.v-btn.v-btn--disabled .v-icon {
  color: rgba(235, 235, 245, 0.6) !important;
}
>>>.theme--dark .highcharts-button-hover .highcharts-button-box,
>>>.theme--dark .highcharts-button-pressed .highcharts-button-box {
  fill: #212121;
}
.theme--dark span.desc {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
  color: rgba(235, 235, 245, 0.6);
}
@media (max-width: 475px) {
  .between-icons {
    margin-left: 0px !important;
  }
}
@media (max-width: 375px) {
  .theme--light span.desc {
    font-family: "Lato", serif !important;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 19px;
    color: #7395d0;
  }
  .theme--dark span.desc {
    font-family: "Lato", serif !important;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 19px;
    color: rgba(235, 235, 245, 0.6);
  }
  .desc-icon {
    margin-right: 4px;
    margin-bottom: -4px;
  }
}
</style>

<script>
import { mapGetters } from "vuex";
import swal from "sweetalert2";
import MarketAllocationsExpandedSettings from "../components/markets/MarketAllocationsExpandedSettings";

export default {
  components: {
    MarketAllocationsExpandedSettings
  },
  data: () => ({
    headers: [
      { text: "Market name", value: "base_currency" },
      { text: "Fractional acc val", value: "managed_acc_val" },
      { text: "Managed val (USD)", value: "managed_value_usd" },
      { text: "Open buys vol", value: "fe_in_open_buys_quote" },
      { text: "Current alloc (%)", value: "current_alloc" },
      { text: "Configured alloc (%)", value: "set_alloc_perc" },
      { text: "Bag size (%)", value: "fe_bag_size_pct" },
      { text: "Unrealised loss", value: "unrealised_loss" },
      { text: "Funding health (%)", value: "fe_funding_health_pct" }
    ],
    pagination: {
      binance: {
        descending: false,
        sortBy: "base_currency"
      },
      bittrex: {
        descending: false,
        sortBy: "base_currency"
      },
      huobi: {
        descending: false,
        sortBy: "base_currency"
      }
    },
    windowWidth: window.innerWidth
  }),
  computed: {
    tableHeaders() {
      if (this.isMobile) {
        return [{ text: "Market name", value: "base_currency" }];
      } else {
        return this.headers;
      }
    },
    isMobile() {
      return this.windowWidth < 768;
    },
    chartData: function() {
      let chartOptions = {
        chart: {
          type: "bar",
          height: "900px",
          backgroundColor: this.darkmode ? "#212121" : "#fff",
          events: {
            render: function() {
              const chart = this;
              chart.series.forEach(function(series) {
                series.points.forEach(function(point) {
                  const dataLabel = point.dataLabel;
                  dataLabel.translate(dataLabel.x, dataLabel.y - 12);
                  if (point.y <= 0) {
                    point.dataLabel.text.css({
                      color: "white",
                      "background-color": "white",
                      display: "none"
                    });
                  }
                });
              });
            },
          }
        },
        title: {
          text: "Insights",
          margin: 40,
          style: {
            color: this.darkmode ? "#E9E9E9" : "#103A84",
            fontSize: "22px",
            fontFamily: "Lato, serif",
            lineHeight: "26px",
            fontWeight: "bold"
          }
        },
        // scrollbar: {
        //   enabled: true
        // },
        xAxis: {
          categories: [],
          labels: {
            align: "Left",
            reserveSpace: true,
            style: {
              color: this.darkmode ? "rgba(235, 235, 245, 0.6)" : "#7395D0",
              fontFamily: "Lato, serif",
              fontSize: "12px",
              lineHeight: "14px"
            }
          }
        },
        yAxis: {
          title: {
            text: "Total allocation (%)",
            align: "high",
            style: {
              color: this.darkmode ? "rgba(235, 235, 245, 0.6)" : "#7395D0",
              fontFamily: "Lato, serif",
              fontSize: "12px",
              lineHeight: "14px"
            }
          },
          labels: {
            style: {
              color: this.darkmode ? "rgba(235, 235, 245, 0.6)" : "#7395D0"
            }
          },
          gridLineColor: this.darkmode ? "#303030" : "#E6EFFF"
        },
        legend: {
          enabled: false,
          useHTML: true,
          reversed: true,
          itemStyle: {
            color: this.darkmode ? "rgba(235, 235, 245, 0.6)" : "#7395D0",
            fontWeight: "normal",
            fontFamily: "Lato, serif"
          }
        },
        plotOptions: {
          series: {
            stacking: "normal",
            pointWidth: 8,
            borderWidth: 0,
            borderRadius: 5
          }
        },
        credits: {
          enabled: false
        },
        exporting: {
          buttons: {
            contextButton: {
              symbol: this.darkmode ? "url(/img/highcharts_menu_dark.svg)" : "url(/img/highcharts_menu_light.svg)",
              width: 32,
              height: 32,
              theme: {
                fill: this.darkmode ? "#212121" : "#ffffff",
              }
            }
          }
        },
        series: [
          {
            name: "In open buy orders",
            data: [],
            color: this.$vuetify.theme.highcharts_buy_color,
            tooltip: {
              headerFormat: "",
              pointFormat: "{point.y:.0f}%"
            },
            dataLabels: {
              enabled: true,
              color: this.$vuetify.theme.highcharts_buy_color,
              format: "{point.y:.0f}", // 0 decimal
              style: {
                textOutline: 0,
                fontSize: "12px",
                fontFamily: "Lato, serif"
              }
            }
          },
          {
            name: "Reserved for selling <i onclick='window.test.chartPopup();event.stopPropagation();' class=\"fas fa-info-circle\" style=\"color: #8691a4 !important\"></i>",
            data: [],
            color: this.$vuetify.theme.highcharts_sell_color,
            tooltip: {
              headerFormat: "",
              pointFormat: "{point.y:.0f}%"
            },
            dataLabels: {
              enabled: true,
              color: this.$vuetify.theme.highcharts_sell_color,
              format: "{point.y:.0f}", // 0 decimal
              style: {
                textOutline: 0,
                fontSize: "12px",
                fontFamily: "Lato, serif"
              }
            }
          },
          {
            name: "",
            data: [],
            color: this.$vuetify.theme.highcharts_sell_no_surplus_color,
            tooltip: {
              headerFormat: "",
              pointFormat: "{point.y:.0f}%"
            },
            dataLabels: {
              enabled: true,
              color: this.$vuetify.theme.highcharts_sell_no_surplus_color,
              format: "{point.y:.0f}", // 0 decimal
              style: {
                textOutline: 0,
                fontSize: "12px",
                fontFamily: "Lato, serif"
              }
            }
          }
        ]
      };

      const allocations = [...this.allocations.data];

      allocations.sort((a, b) => this.sortMarkets(a, b));

      allocations.map(market => {
        if (market.exchange === "Bittrex") {
          market.market_name_graph =
            market.exchange +
            ":" +
            market.market_name
              .replace(market.exchange + ":", "")
              .replace(market.base_currency, "")
              .replace("-", "") +
            "/" +
            market.base_currency;
        } else {
          market.market_name_graph =
            market.exchange +
            ":" +
            market.market_name
              .replace(market.exchange + ":", "")
              .replace(market.base_currency, "") +
            "/" +
            market.base_currency;
        }
        chartOptions.xAxis.categories.push(market.market_name_graph);
        chartOptions.series[0].data.push(Math.round(market.fe_in_open_buys_pct));
        chartOptions.series[1].data.push(Math.round(market.fe_reserved_for_selling_surplus_pct));
        chartOptions.series[2].data.push(Math.round(market.fe_reserved_for_selling_no_surplus_pct));
      });
      return chartOptions;
    },
    binanceAllocations() {
      let array = this.allocations.data.filter(
        market => market.market_name.indexOf("Binance:") === 0
      );
      if (array.length) {
        array.forEach(function(item) {
          item.market_name_table =
            item.market_name
              .replace(item.exchange + ":", "")
              .replace(item.base_currency, "") +
            "/" +
            item.base_currency;
        });
      }
      return array;
    },
    bittrexAllocations() {
      let array = this.allocations.data.filter(
        market => market.market_name.indexOf("Bittrex:") === 0
      );
      if (array.length) {
        array.forEach(function(item) {
          item.market_name_table =
            item.market_name
              .replace(item.exchange + ":", "")
              .replace(item.base_currency, "")
              .replace("-", "") +
            "/" +
            item.base_currency;
        });
      }
      return array;
    },
    huobiAllocations() {
      let array = this.allocations.data.filter(
        market => market.market_name.indexOf("Huobi:") === 0
      );
      if (array.length) {
        array.forEach(function(item) {
          item.market_name_table =
            item.market_name
              .replace(item.exchange + ":", "")
              .replace(item.base_currency, "") +
            "/" +
            item.base_currency;
        });
      }
      return array;
    },
    ...mapGetters({
      darkmode: "settings/darkmode",
      allocations: "markets/allocations",
      user: "auth/user"
    })
  },
  created: function() {
    if (this.$store.getters["markets/allocations"].data.length === 0) {
      this.$store.dispatch("markets/fetchAllocations");
    }
  },
  mounted() {
    window.onresize = () => {
      this.windowWidth = window.innerWidth;
    };
    window.test = this;
  },
  methods: {
    chartPopup() {
      this.infoAlert(
        this.$t("information.reserved_for_selling.title"),
        this.$t("information.reserved_for_selling.description")
      );
    },
    sortMarkets(a, b, factor = 1) {
      if (a.exchange !== b.exchange) {
        return factor * (a.exchange < b.exchange ? -1 : 1);
      }

      if (a.base_currency !== b.base_currency) {
        return factor * (a.base_currency < b.base_currency ? -1 : 1);
      }

      return factor * (a.market_name < b.market_name ? -1 : 1);
    },

    customTableSort(items, index, isDescending) {
      const factor = isDescending ? -1 : 1;
      if (index === "market_name") {
        items.sort((a, b) => this.sortMarkets(a, b, factor));
      } else {
        items.sort((a, b) => {
          const aValue = a[index];
          const bValue = b[index];

          if (aValue === bValue) {
            return 0;
          }

          return factor * (aValue < bValue ? -1 : 1);
        });
      }

      return items;
    },
    infoAlert: async function(title, text) {
      await swal({
        title: title,
        html: text,
        showConfirmButton: false,
        showCloseButton: true,
        customClass: this.darkmode ? "swal-type-info-dark" : "swal-type-info"
      });
    },
    changeSort: function(header, exchange) {
      this.pagination[exchange].sortBy = header.value;
      this.pagination[exchange].descending = !this.pagination[exchange]
        .descending;
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/js/pages/marketallocations.vue